import script from "./AppUnavailablePageLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./AppUnavailablePageLayout.vue?vue&type=script&setup=true&lang=js"

import "./AppUnavailablePageLayout.vue?vue&type=style&index=0&id=ffa5e272&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ffa5e272"]])

export default __exports__